// License Audit (verification history) filter registry. Drives the
// Audit tab on the license detail page.

import { createDateRangeFilter } from './factories';
import type { FilterRegistry } from './types';

const LICENSE_AUDIT_LIST_KEYS: ReadonlyArray<string> = [
	'license-audit-embedded',
];

export const licenseAuditFilters: FilterRegistry = {
	auditCheckType: {
		type: 'multi-select',
		label: 'Check Type',
		placeholder: 'Select check type...',
		colorScheme: 'blue',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: [
			{ id: 'PORTAL_DETAIL', label: 'Portal check' },
			{ id: 'API_DETAIL', label: 'API check' },
			{ id: 'BULK_IMPORT', label: 'Bulk import' },
		],
		queryParamName: 'auditCheckType',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_verification_log',
			fieldName: 'check_type',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_AUDIT_LIST_KEYS],
	},

	auditStatusNormalized: {
		type: 'multi-select',
		label: 'Status at Check',
		placeholder: 'Select status...',
		colorScheme: 'orange',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: [
			{ id: 'Active', label: 'Active' },
			{ id: 'Expired', label: 'Expired' },
			{ id: 'Pending', label: 'Pending' },
			{ id: 'Revoked', label: 'Revoked' },
			{ id: 'Suspended', label: 'Suspended' },
			{ id: 'Cancelled', label: 'Cancelled' },
			{ id: 'Other', label: 'Other' },
		],
		queryParamName: 'auditStatusNormalized',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_verification_log',
			fieldName: 'status_normalized_at_check',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_AUDIT_LIST_KEYS],
	},

	auditDisciplinary: {
		type: 'radio',
		label: 'Disciplinary at Check',
		colorScheme: 'red',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		queryParamName: 'auditDisciplinary',
		multiple: false,
		options: [
			{ id: 'all', label: 'All' },
			{ id: 'yes', label: 'With disciplinary' },
			{ id: 'no', label: 'Clean' },
		],
		defaultValue: { id: 'all', label: 'All' },
		queryMapping: {
			objectTable: 'lm_verification_log',
			fieldName: 'has_disciplinary_at_check',
			joinType: 'custom',
		},
		format: 'single',
		valueExtractor: { property: 'id' },
		listKeys: [...LICENSE_AUDIT_LIST_KEYS],
	},

	auditDateRange: {
		...createDateRangeFilter({
			label: 'Check Date',
			objectTable: 'lm_verification_log',
			dateField: 'checked_at',
			listKeys: [...LICENSE_AUDIT_LIST_KEYS],
		}),
		queryParamName: 'auditDateRange',
	},
};
